// Custom Navigation JavaScript
// Add this to both malaphortune-theme.js and unprofitable-theme.js

// Initialize navigation on DOM load
document.addEventListener('DOMContentLoaded', function() {
  initCustomNavigation();
});

function initCustomNavigation() {
  const toggle = document.getElementById('u-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const subMenuButtons = document.querySelectorAll('.u-subbtn');
  
  // Mobile menu toggle
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function() {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        mobileMenu.setAttribute('hidden', '');
      } else {
        mobileMenu.removeAttribute('hidden');
      }
    });
  }
  
  // Submenu toggles in mobile
  subMenuButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const submenu = button.nextElementSibling;
      
      if (submenu) {
        button.setAttribute('aria-expanded', !isExpanded);
        submenu.setAttribute('aria-hidden', isExpanded);
      }
    });
  });
  
  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    if (toggle && mobileMenu && !mobileMenu.hasAttribute('hidden')) {
      if (!toggle.contains(e.target) && !mobileMenu.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('hidden', '');
      }
    }
  });
}